<template>
    <b-card>
        <b-card-header>
            <h1>Order</h1>
        </b-card-header>
        <b-card-body>
            <!-- <b-row>
                <b-col cols="4">
                    <b-form-select class="form-control" v-model="newEvent.EventTypeId" :options="GetEventTypes()">
                    </b-form-select>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col>
                    <tableedit v-if="editMode" v-bind:recs="recs" v-bind:cols="fields" v-bind:readonly="!editMode"
                        savebuttontext="Posta in" cancelHidden="true" @save="onSave" @cancel="onCancel">
                    </tableedit>
                </b-col>
            </b-row>

        </b-card-body>
    </b-card>
</template>
<script>
import tableedit from "../logic/tableedit";
import { Api } from "../../lib/api";
const api = new Api();

//Kortnamn	Märkning	Förnamn	Efternamn	Kundnr	Personnr	Känslighet	Portionsstorlek	Kommentar	Portkod	Adress	Postnr	Postadress	Övriga uppgifter1	Övriga uppgifter2

export default {
    name: 'registerdata',
    components: { tableedit },
    data() {
        return {
            recs: [],
            editMode: false,
            fields: [
                //Kortnamn	Märkning	Förnamn	Efternamn	Kundnr	Personnr	Känslighet	Portionsstorlek	Kommentar	Portkod	Adress	Postnr	Postadress	Övriga uppgifter1	Övriga uppgifter2
                //     { id: 0, caption: "Kortnamn", field: "tspDocNo", type: "text", items: null },
                //     { id: 1, caption: "Märkning", field: "comment", type: "text", items: null },
                //     { id: 2, caption: "Förnamn", field: "productKey", type: "text", items: null },
                //     { id: 3, caption: "Efternamn", field: "revisedCost", type: "string", items: null },
                //     { id: 4, caption: "Kundnr", field: "result", type: "string", items: null },
                //     { id: 5, caption: "Personnr", field: "result", type: "string", items: null },
                //     { id: 6, caption: "Känslighet", field: "result", type: "string", items: null },
                //     { id: 7, caption: "Portionsstorlek", field: "result", type: "string", items: null },
                //     { id: 8, caption: "Kommentar", field: "result", type: "string", items: null },
                //     { id: 9, caption: "Portkod", field: "result", type: "string", items: null },
                //  { id: 10, caption: "Adress", field: "result", type: "string", items: null },
                //        { id: 11, caption: "Postnr", field: "result", type: "string", items: null },
                //     { id: 12, caption: "Postadress", field: "result", type: "string", items: null },
                //     { id: 13, caption: "Övriga uppgifter1", field: "result", type: "string", items: null },
                //     { id: 14, caption: "Övriga uppgifter2", field: "result", type: "string", items: null },
  { id: 0, caption: "OK", field: "success", type: "boolean", items: null },
                { id: 1, caption: "RESULTAT", field: "errMsg", type: "text", items: null },
              { id: "2", caption: "Följesedelsnr", field: "Foljesedelsnr", type: "text", items: null },
{ id: "3", caption: "Datum", field: "Datum", type: "text", items: null },
{ id: "4", caption: "Leverantör", field: "Leverantor", type: "text", items: null },
{ id: "5", caption: "Partgrupp", field: "Partgrupp", type: "text", items: null },
{ id: "6", caption: "Part(Id)", field: "PartId", type: "text", items: null },
{ id: "7", caption: "Part(Kund)", field: "PartKund", type: "text", items: null },
{ id: "8", caption: "Part(Kundkod)", field: "PartKundKod", type: "text", items: null },
{ id: "9", caption: "Kundnamn", field: "Kundnamn", type: "text", items: null },
{ id: "10", caption: "Personnummer", field: "Personnummer", type: "text", items: null },
{ id: "11", caption: "Kundummer", field: "Kundummer", type: "text", items: null },
{ id: "12", caption: "Adressrad 1", field: "Adressrad1", type: "text", items: null },
{ id: "13", caption: "Adressrad 2", field: "Adressrad2", type: "text", items: null },
{ id: "14", caption: "Postnummer", field: "Postnummer", type: "text", items: null },
{ id: "15", caption: "Postadress", field: "Postadress", type: "text", items: null },
{ id: "16", caption: "Telefon", field: "Telefon", type: "text", items: null },
{ id: "17", caption: "Email", field: "Email", type: "text", items: null },
{ id: "18", caption: "Utbud", field: "Utbud", type: "text", items: null },
{ id: "19", caption: "Avtal", field: "Avtal", type: "text", items: null },
{ id: "20", caption: "Matsedel", field: "Matsedel", type: "text", items: null },
{ id: "21", caption: "Servering", field: "Servering", type: "text", items: null },
{ id: "22", caption: "Alternativ", field: "Alternativ", type: "text", items: null },
{ id: "23", caption: "Alternativgrupp", field: "Alternativgrupp", type: "text", items: null },
{ id: "24", caption: "Produkt(Id)", field: "ProduktId", type: "text", items: null },
{ id: "25", caption: "Menykomponent", field: "Menykomponent", type: "text", items: null },
{ id: "26", caption: "PrislistaGroup", field: "PrislistaGroup", type: "text", items: null },
{ id: "27", caption: "Varugrupp", field: "Varugrupp", type: "text", items: null },
{ id: "28", caption: "Portionsstorlek", field: "Portionsstorlek", type: "text", items: null },
{ id: "29", caption: "Pris", field: "Pris", type: "text", items: null },
{ id: "30", caption: "Antal", field: "Antal", type: "text", items: null },
{ id: "31", caption: "Summa", field: "Summa", type: "text", items: null },
{ id: "32", caption: "Unit", field: "Unit", type: "text", items: null },
{ id: "33", caption: "Betalsätt", field: "Betalsatt", type: "text", items: null },
{ id: "34", caption: "FaktureringsArt.", field: "FaktureringsArt", type: "text", items: null },
{ id: "35", caption: "tom", field: "tom", type: "text", items: null },
{ id: "36", caption: "tom", field: "tom1", type: "text", items: null },
{ id: "37", caption: "Uppdrag", field: "Uppdrag", type: "text", items: null },
{ id: "38", caption: "Samlingsfaktura", field: "Samlingsfaktura", type: "text", items: null },
{ id: "39", caption: "Kundnummer", field: "Kundnummer", type: "text", items: null },
{ id: "40", caption: "Adresspekare", field: "Adresspekare", type: "text", items: null },
{ id: "41", caption: "Referens_1", field: "Referens_1", type: "text", items: null },
{ id: "42", caption: "Referans_2", field: "Referans_2", type: "text", items: null },
{ id: "43", caption: "Vår_referens", field: "Var_Ref", type: "text", items: null },
{ id: "44", caption: "Betalningsvilkor", field: "Betalningsvilkor", type: "text", items: null },
{ id: "45", caption: "Kommentar", field: "Kommentar", type: "text", items: null },


            ]
        }
    },
    created() {
        this.recs = [];
        var id = 0;
        this.fields.forEach(it => it.id = id++);
        this.editMode = true;
    },
    methods: {
        onSave(r) {
            if (confirm("Vill du posta in data?")) {
                var dt = [];

                dt = JSON.parse(JSON.stringify(r));
                if (dt.length == 0) {
                    alert('Finns inga poster att lägga in.');
                    return;
                }
                //var dt = r.map(x => { return {tspDocNo: x.tspDocNo, comment: x.comment, productKey: x.productKey, revisedCost: Number(x.revisedCost.replace(',','.'))}});
                api.post('/api/sodexo/RegisterOrders', dt).then(res => {
                    //this.recs = res.data;
                    // let r = res.data;
                    // for (var i = 0; i < r.length; i++) {
                    //     var rec = this.recs[i];
                    //     this.recs[i].errMsg = r[i].errMsg;
                    //     this.recs[i].success = r[i].success;
                    // }
                    this.recs = res.data;
                    alert('Poster behandlade. Se resultat i resultatkolumnen.')
                });
            }

        },
        onCancel(r) {
            if (confirm("Vill du avbryta?")) {
                this.recs = [];
            }
        }
    }
}
</script>